(ns ui.page
  (:require [ui.typography :as typography]
            [ui.utils :refer [clsx separate-props]]
            ["lucide-react" :refer [Loader2]]
            [minorodata.components.spinner.core :as spinner]))

(defn page-header [& args]
  (let [[props children] (separate-props args)]
    [:header (-> props
                 (dissoc :content-props :variant)
                 (update :class #(clsx "sticky top-0 z-10 bg-kleene-background"
                                       (case (:variant props)
                                         :border "border-b"
                                         "shadow-layout")
                                       %)))
     (into [:div (-> (:content-props props)
                     (update :class #(clsx "px-6 py-4" %)))]
           children)]))

(defn page-root [& args]
  (let [[props children] (separate-props args)]
    [:div {:class (clsx "min-h-screen h-screen" (get-in props [:classes :root]))}
     (into [:div (-> props
                     (dissoc :classes)
                     (update :class #(clsx "flex flex-col h-screen overflow-y-auto" %)))]
           children)]))

(defn page-content [& args]
  (let [[props children] (separate-props args)]
    (into [:div (-> props
                    (dissoc :variant)
                    (update :class #(clsx "relative flex-1"
                                          (case (:variant props)
                                            :border "bg-kleene-background overflow-hidden"
                                            "p-6 bg-kleene-background-secondary")
                                          %)))]
          children)))

(defn page-columns [& args]
  (let [[props children] (separate-props args)]
    (into [:div (-> props
                    (update :class #(clsx "h-full grid grid-cols-[300px_1fr] 2xl:grid-cols-[400px_1fr] overflow-hidden *:first:border-r"
                                          %)))]
          children)))

(defn page-title [& args]
  (let [[props children] (separate-props args)]
    (into [typography/h1 props] children)))

(defn page-controls [& args]
  (let [[props children] (separate-props args)]
    (into [:div (-> props
                    (update :class #(clsx "mt-2" %)))]
          children)))

(defn page-description [& args]
  (let [[props children] (separate-props args)]
    (into [typography/p (-> props
                            (update :class #(clsx "text-kleene-text-secondary" %)))] children)))

(defn page-layout [{:keys [title post-header header-props]} children]
  [page-root
   [page-header
    [page-title header-props title]
    post-header]
   [page-content children]])

(defn page-loading-screen []
  [:div {:class "flex items-center justify-center h-full"}
   [spinner/with-text {:text "Loading..."}]])